import lessonEdit from "./lessonEdit.vue";
export default lessonEdit;
